export enum ConditionCommunications {
    Email = "Email",
    None = "None"
}